import { render } from "./promotion_approval.vue?vue&type=template&id=c44f0a30"
import script from "./promotion_approval.vue?vue&type=script&lang=js"
export * from "./promotion_approval.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__